"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminWatchers = exports.adminReducers = void 0;
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const authentication_1 = require("./authentication/index.js");
const customers_1 = require("./customers/index.js");
const feature_flags_1 = require("./feature-flags/index.js");
const oidc_configurations_1 = require("./oidc-configurations/index.js");
const search_1 = require("./search/index.js");
const users_1 = require("./users/index.js");
exports.adminReducers = (0, redux_1.combineReducers)({
    authentication: authentication_1.adminAuthenticationReducers,
    customers: customers_1.adminCustomersReducers,
    featureFlag: feature_flags_1.adminFeatureFlagsReducers,
    oidcConfigurations: oidc_configurations_1.adminOidcConfigurationsReducers,
    search: search_1.adminSearchReducers,
    users: users_1.adminUsersReducers
});
exports.adminWatchers = (0, xuder_1.combineAllWatchers)([
    authentication_1.adminAuthenticationWatchers,
    customers_1.adminCustomersWatchers,
    feature_flags_1.adminFeatureFlagsWatchers,
    oidc_configurations_1.adminOidcConfigurationsWatchers,
    search_1.adminSearchWatchers,
    users_1.adminUsersWatchers
]);
//# sourceMappingURL=index.js.map